const markdownTableStyles = {
	'& table': {
		borderCollapse: 'collapse',
		width: 'max-content',
		borderSpacing: 0,
		// Tiptap sets an inline min-width on the table
		minWidth: '100% !important',
	},
	// Tiptap renders the header row inside <tbody>, so there's no <thead>
	'& tr:has(> th)': {
		borderBottom: '1px solid lightgray',
	},
	'& th': {
		padding: '8px 6px',
		textAlign: 'left',
		whiteSpace: 'nowrap',
	},
	'& th:not(:last-child)': {
		borderRight: '1px solid lightgray',
	},
	'& td': {
		padding: '8px 6px',
		textAlign: 'left',
	},
	'& td:not(:last-child)': {
		borderRight: '1px solid lightgray',
	},
};
export default markdownTableStyles;
